import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize } from 'rxjs';
import { ButtonPadraoComponent } from '../../shared/components/button-padrao/button-padrao.component';
import { FormFieldComponent } from '../../shared/components/form-field/form-field.component';
import { SlideTogglePadraoComponent } from '../../shared/components/slide-toggle-padrao/slide-toggle-padrao.component';
import { ParametroIntegraXSmsModel } from '../../shared/model/parametros/parametro-integrax-sms.model';
import { MsgService } from '../../shared/service/msg.service';
import { ParametroIntegraXSmsService } from '../../shared/service/parametro-integrax-sms.service';
import { SelectOneComponent } from '../../shared/components/select-one/select-one.component';

@Component({
  selector: 'app-card-integrax-sms',
  standalone: true,
  imports: [SlideTogglePadraoComponent, FormFieldComponent, ButtonPadraoComponent, SelectOneComponent],
  templateUrl: './card-integrax-sms.component.html',
  styleUrl: '../card-aws-ses/card-aws-ses.component.css'
})
export class CardIntegraXSmsComponent implements OnInit {
  private readonly parametroService = inject(ParametroIntegraXSmsService);
  private readonly msgService = inject(MsgService);
  private readonly destroyRef = inject(DestroyRef);

  parametro = new ParametroIntegraXSmsModel();
  salvando = false;
  carregando = true;
  readonly opcoesMoeda = [
    { id: 'BRL', nome: 'Real' },
    { id: 'USD', nome: 'Dólar' },
    { id: 'EUR', nome: 'Euro' }
  ];

  ngOnInit(): void {
    this.buscarParametros();
  }

  buscarParametros(): void {
    this.parametroService.buscar()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: res => {
          this.parametro = res ?? new ParametroIntegraXSmsModel();
          this.parametro.ativo ??= true;
          this.parametro.moedaCusto ??= 'USD';
          this.carregando = false;
        },
        error: () => {
          this.carregando = false;
          this.msgService.msgErro('Erro ao buscar as configurações da IntegraX');
        }
      });
  }

  atribuirValorMensagem(valor: unknown): void {
    if (valor === '' || valor == null) {
      this.parametro.valorMensagem = undefined;
      return;
    }
    const numero = typeof valor === 'number'
      ? valor
      : Number(String(valor).replace(/[^\d.-]/g, ''));
    this.parametro.valorMensagem = Number.isFinite(numero) ? numero : undefined;
  }

  selecionarMoeda(opcao?: { id: string }): void {
    if (opcao) this.parametro.moedaCusto = opcao.id as 'BRL' | 'USD' | 'EUR';
  }

  obterMoeda() {
    return this.opcoesMoeda.find(opcao => opcao.id === this.parametro.moedaCusto);
  }

  obterSimboloMoeda(): string {
    return this.parametro.moedaCusto === 'BRL'
      ? 'R$'
      : this.parametro.moedaCusto === 'EUR' ? '€' : 'US$';
  }

  salvar(): void {
    if (this.salvando || !this.validarCampos()) return;

    this.salvando = true;
    this.parametroService.salvar(this.parametro)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => this.salvando = false)
      )
      .subscribe({
        next: () => {
          this.msgService.msgSucesso('Configurações da IntegraX salvas com sucesso');
          this.buscarParametros();
        },
        error: erro => this.msgService.msgErro(
          erro?.error?.reason ?? erro?.error?.message ?? 'Erro ao salvar as configurações da IntegraX'
        )
      });
  }

  private validarCampos(): boolean {
    if (!this.validarTexto(this.parametro.token, 256, 'Preencha o Token da IntegraX', 'O Token deve ter no máximo 256 caracteres')) return false;
    if (!this.validarTexto(this.parametro.remetente, 32, 'Preencha o Remetente', 'O Remetente deve ter no máximo 32 caracteres')) return false;
    if (this.parametro.valorMensagem == null || this.parametro.valorMensagem < 0) {
      this.msgService.msgAdvertencia('Preencha um Valor por mensagem maior ou igual a zero');
      return false;
    }
    if (!this.parametro.moedaCusto) {
      this.msgService.msgAdvertencia('Selecione a moeda do valor por mensagem');
      return false;
    }
    if (!this.validarTexto(this.parametro.usuario, 256, 'Preencha o Usuário de acesso à API IntegraX', 'O Usuário deve ter no máximo 256 caracteres')) return false;
    return this.validarTexto(this.parametro.senha, 256, 'Preencha a Senha de acesso à API IntegraX', 'A Senha deve ter no máximo 256 caracteres');
  }

  private validarTexto(valor: string | undefined, maximo: number, mensagemObrigatorio: string, mensagemTamanho: string): boolean {
    if (!valor?.trim()) {
      this.msgService.msgAdvertencia(mensagemObrigatorio);
      return false;
    }
    if (valor.length > maximo) {
      this.msgService.msgAdvertencia(mensagemTamanho);
      return false;
    }
    return true;
  }
}
